import { render, staticRenderFns } from "./MultiSelectorCompeticao.vue?vue&type=template&id=73698b92&scoped=true"
import script from "./MultiSelectorCompeticao.vue?vue&type=script&lang=js"
export * from "./MultiSelectorCompeticao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73698b92",
  null
  
)

export default component.exports